import { Component, OnInit } from "@angular/core";
import {
  trigger,
  transition,
  style,
  animate,
  state,
  query,
  stagger,
  group
} from "@angular/animations";
import { ROUTES } from "../common.routes";
import { MenuServiceService } from "src/app/_services/menu-service.service";
import { RouteInfo } from "src/app/_modules/route.module";
import { ActivatedRoute, NavigationStart } from "@angular/router";
import { Location } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { SigninComponent } from "../signin/signin.component";
import { enteranimate } from "src/app/route-animations";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { CommonService } from 'src/app/_services/common.service';
import { job_category_menu } from 'src/app/_model/shared_url';
// declare var $:any;
// declare var TimelineMax:any;
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  animations: [
     trigger("slideInOut", [
      transition(":enter", [
        style({ transform: "translateX(-100%)", opacity: 0 }),
        animate(
          "0.5s ease-in-out",
          style({ transform: "translateX(0%)", opacity: 1 })
        )
      ]),
      transition(":leave", [
        style({ transform: "translateX(0%)", opacity: 1 }),
        animate(
          "1s ease-out",
          style({ transform: "translateX(-100%)", opacity: 0 })
        )
      ])
    ]),
    trigger("slideOutIn", [
      transition(":enter", [
        style({ transform: "translateX(10%)", opacity: 0 }),
        animate(
          "0.5s ease-in-out",
          style({ transform: "translateX(0%)", opacity: 1 })
        )
      ]),
      transition(":leave", [
        style({ transform: "translateX(0%)", opacity: 1 }),
        animate(
          "1s ease-out",
          style({ transform: "translateX(10%)", opacity: 0 })
        )
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {
  openVisible;
  visibilityOpen;
  listTitles: any[];
  routerSubscription: any;
  temppath: any;
  showhead;
  visibilitycustomOpen;
  visibleMenu: boolean = true;
  open: boolean;
  sub_nav: any;
  show = false;
  aboutMenus=[];
  enggMenus=[];
  projectMenu=[];
  careerMenu=[];
  activeValue: any;
  titles: any;
  title: any;
  innerWidth: number;
  docmenu= [];
  userName: any;
  constructor(
    public menu: MenuServiceService,
    private route: ActivatedRoute,
    private location: Location,
    public dialog: MatDialog,
    private common:CommonService,
    private auth: AuthenticationService
  ) {
    this.visibilitycustomOpen = this.menu.changesOpen(
      this.visibilitycustomOpen
    );
    // console.log(this.auth.currentUserValue);
    let value = this.auth.currentUserValue;
    // this.visibilitycustomOpen = false;
    
    if (value) {
      if (value.status == true && value["status"] !== null){
      console.log(value['loginDetails'])

        this.userName = value['loginDetails']['ros_username'];
        this.visibleMenu = false;
      }
      // this.route.navigate(["/"]);
    } else {
      this.visibleMenu = true;
    }
    this.temppath = "." + this.location.path();
  }
  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.menu.getDocMenu().subscribe((data:any) => {
      console.log(data)
      this.docmenu = data;
    })
    this.menu.getaboutMenu().subscribe((aboutMenuValue:any) => {
      //  console.log(aboutMenuValue);
           aboutMenuValue.forEach(element => {
             if (element.about_status === "1") {
               this.aboutMenus.push(element);
             }
           });
      })
      this.menu.getenggMenu().subscribe((responseData: any) => {
        // console.log(responseData);
        this.enggMenus = responseData;
      });
      this.menu.getprojectMenu().subscribe((responseData: any) => {
        console.log(responseData);
        responseData.forEach(element => {
          if(element.project_status === '1')
          this.projectMenu.push(element)
        });
      });
  
    let screen_width = document.documentElement.clientWidth;
    //  let  screen_heght = document.documentElement.clientHeight;
    //  console.log(screen_width, screen_heght);
    this.menu.getMainMenu().subscribe((data: any) => {
      // console.log(data);
      this.listTitles = data;
    });
    this.visibilitycustomOpen = this.menu.changesOpen(
      this.visibilitycustomOpen
    );
    // this.listTitles = ROUTES.filter(listTitle => listTitle);
    // console.log(this.visibilitycustomOpen);
    // this.showhead = false;
    // this.visibilityOpen = false;
    // console.log(this.temppath);
    var splitted = this.temppath.split("/", 3);
    // console.log(splitted);
    this.temppath = "./" + splitted[1];
    this.changePath(this.temppath);
    // if (this.temppath === "./home" || this.temppath === "./") {
    //   let open = false;
    //   this.openVisible = this.menu.changesOpen(open);
    //   this.temppath = "./home";
    //   this.visibilitycustomOpen = false;
    //   this.visibilitycustomOpen = this.menu.changesOpen(
    //     this.visibilitycustomOpen
    //   );
    //   //   // this.showhead = true;
    // } else 
    {
      if (screen_width <= 799) {
        this.open = false;
        this.visibilitycustomOpen = false;
      } else {
        this.open = true;
        this.visibilitycustomOpen = true;
      }
      this.openVisible = this.menu.changesOpen(this.open);
      this.visibilitycustomOpen = this.menu.changesOpen(
        this.visibilitycustomOpen
      );
    }
  }
  changeVisible() {
    this.visibilityOpen = !this.visibilityOpen;
    this.showhead = !this.showhead;
  }
  changePath(path) {
    this.open = true;
    // console.log(open);
    this.temppath = path;
    if (this.temppath === "./home" || this.temppath === "./") {
      this.visibilitycustomOpen = false;
      this.visibilitycustomOpen = this.menu.changesOpen(
        this.visibilitycustomOpen
      );
    } else {
      this.visibilitycustomOpen = true;
      this.visibilitycustomOpen = this.menu.changesOpen(
        this.visibilitycustomOpen
      );
    }
    this.openVisible = this.menu.changesOpen(open);
    // this.openVisible = !this.openVisible;
  }
  logout() {
    this.auth.logout();
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(SigninComponent, {
      width: "100vw",
      height: "100vh"
      // data: { name: this.childimage }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log("The dialog was closed");
      // this.animal = result;
    });
  }
  locations(value) {
    // console.log(value);
    this.temppath = value;
    if (this.temppath === "./home") {
      this.visibilitycustomOpen = false;
      this.visibilitycustomOpen = this.menu.changesOpen(
        this.visibilitycustomOpen
      );
    }
  }
  close() {
    this.openVisible = false;
  }
  opensub(value) {
    console.log(value);
    this.sub_nav = value;
    this.show = !this.show;
  }
 
}
